"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import { ConfigEarlyWarningFormController } from "@/views/safemanagements/InprogressManager/components/ConfigEarlyWarning.vue";
import i18n from "@/lang";
import MembersChooseDialog from "@/views/safemanagements/InprogressManager/dialogs/MembersChooseDialog.vue";
import DepartmentsChooseDialog from "@/views/safemanagements/InprogressManager/dialogs/DepartmentsChooseDialog.vue";
import AddInprogressShopsDialog from "@/views/safemanagements/InprogressManager/dialogs/AddInprogressShopsDialog.vue";
let ConfigEarlyLeftWarning = class extends Vue {
  constructor() {
    super(...arguments);
    this.notice_way_list = [
      {
        label: i18n.t("config_early_warning.form.notice_way_1"),
        value: "SEND_MESSAGE"
      },
      {
        label: i18n.t("config_early_warning.form.notice_way_2"),
        value: "ONLY_RECORD"
      }
    ];
    this.notice_members_list = [
      {
        label: i18n.t("config_early_warning.form.notice_members_1"),
        value: "MAIN_ACCOUNT"
      },
      {
        label: i18n.t("config_early_warning.form.notice_members_2"),
        value: "MANAGER"
      }
    ];
    this.handling_measures_members_list = [
      {
        label: this.$t("config_early_warning.form.trigger_condition_all_members"),
        value: "ALL_SUBACCOUNT"
      },
      {
        label: this.$t(
          "config_early_warning.form.trigger_condition_selected_members"
        ),
        value: "USERS"
      },
      {
        label: this.$t(
          "config_early_warning.form.trigger_condition_selected_departments"
        ),
        value: "DEPARTMENT"
      }
    ];
    this.trigger_condition_type_list = [
      {
        label: i18n.t("config_early_warning.form.trigger_condition_all_shops"),
        value: "ALL"
      },
      {
        label: i18n.t("config_early_warning.form.trigger_condition_selected_shops"),
        value: "SPECIFIED"
      }
    ];
    this.handling_measures_type = "ALL_SUBACCOUNT";
    this.handling_measures_members = [];
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  checkChangeHandlingMeasuresType() {
    return __async(this, null, function* () {
      if (this.handling_measures_type === "ALL_SUBACCOUNT") {
        this.handling_measures_type = "ALL_SUBACCOUNT";
        this._formController.handling_measures_type = "ALL_SUBACCOUNT";
        this.handling_measures_members = [];
        this._formController.handling_measures_members = [];
      }
      if (this.handling_measures_type === "USERS" && this._formController.handling_measures_type === "USERS") {
        this._memebersChooseDialog.open(
          this._formController.handling_measures_members
        );
      }
      if (this.handling_measures_type === "USERS" && this._formController.handling_measures_type !== "USERS") {
        this._memebersChooseDialog.open([]);
      }
      if (this.handling_measures_type === "DEPARTMENT" && this._formController.handling_measures_type === "DEPARTMENT") {
        this._departmentsChooseDialog.open(
          this._formController.handling_measures_members
        );
      }
      if (this.handling_measures_type === "DEPARTMENT" && this._formController.handling_measures_type !== "DEPARTMENT") {
        this._departmentsChooseDialog.open([]);
      }
    });
  }
  saveUsers(data) {
    return __async(this, null, function* () {
      try {
        this.handling_measures_type = "USERS";
        this.handling_measures_members = data;
        this._formController.handling_measures_type = "USERS";
        this._formController.handling_measures_members = data;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeDepartments(data) {
    return __async(this, null, function* () {
      try {
        this.handling_measures_type = "DEPARTMENT";
        this.handling_measures_members = data;
        this._formController.handling_measures_type = "DEPARTMENT";
        this._formController.handling_measures_members = data;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  closeDepartments() {
    this.handling_measures_type = this._formController.handling_measures_type;
    this.handling_measures_members = this._formController.handling_measures_members;
  }
  closeMembers() {
    this.handling_measures_type = this._formController.handling_measures_type;
    this.handling_measures_members = this._formController.handling_measures_members;
  }
  openMembersChooseDialog() {
    this._memebersChooseDialog.open(this.handling_measures_members);
  }
  openDepartmentsChooseDialog() {
    this._departmentsChooseDialog.open(this.handling_measures_members);
  }
  changeEnvShops(data) {
    return __async(this, null, function* () {
      this._formController.trigger_condition_shops = data.selectedShops;
    });
  }
  changeTriggerConditionType() {
    console.log(this._formController.trigger_condition_type);
    if (this._formController.trigger_condition_type === "ALL") {
      this._formController.trigger_condition_shops = [];
    }
    if (this._formController.trigger_condition_type === "SPECIFIED") {
      this._addInprogressShopsDialog.open();
    }
  }
  openAddInprogressShopsDialog() {
    this._addInprogressShopsDialog.open(this._formController.trigger_condition_shops);
  }
};
__decorateClass([
  PropSync("formController", {
    type: Object,
    default: () => new ConfigEarlyWarningFormController()
  })
], ConfigEarlyLeftWarning.prototype, "_formController", 2);
__decorateClass([
  PropSync("warningType", {
    type: String,
    default: () => "config"
  })
], ConfigEarlyLeftWarning.prototype, "_warningType", 2);
__decorateClass([
  Ref("membersChooseDialog")
], ConfigEarlyLeftWarning.prototype, "_memebersChooseDialog", 2);
__decorateClass([
  Ref("departmentsChooseDialog")
], ConfigEarlyLeftWarning.prototype, "_departmentsChooseDialog", 2);
__decorateClass([
  Ref("addInprogressShopsDialog")
], ConfigEarlyLeftWarning.prototype, "_addInprogressShopsDialog", 2);
ConfigEarlyLeftWarning = __decorateClass([
  Component({
    components: {
      MembersChooseDialog,
      DepartmentsChooseDialog,
      AddInprogressShopsDialog
    }
  })
], ConfigEarlyLeftWarning);
export {
  ConfigEarlyLeftWarning as default
};
